/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import SidePopup from '../../../../../components/SidePopup'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { dataService } from '../../../../../services/data.services';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import SearchShimmer from '../../../../../components/Shimmer/SearchShimmer';
import GlobalContext from '../../../../../components/Context/GloablContext';
import Loader from '../../../../../components/Loader';

export default function ChangeOngoingFY({handleSidePopupClick, ongoingFY, getFinancialYearRecodes}) {
    const {setToastmessage, setToastErrorMessage} = useContext(GlobalContext);
    const [actionErrorMessage, setActionErrorMessage] = useState("");
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [dropdownValue, setDropDownValue] = useState({})
    const [changedOngoingFY, setChangedOngoingFY] = useState({})
    const [loadingDropdown, setLoadingDropdown] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false)
    const dropDownRef = useRef();
    const [changedStatus, setChangedStatus] = useState({})
    /**
     * The handleDropdownToggle function toggles the state of the dropDownOpen variable.
     */
    const handleDropdownToggle = () => {
        setDropDownOpen(!dropDownOpen); 
    }

    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the dropdown menu. When a click is
    detected outside of the dropdown menu, the `setDropDownOpen` function is called to set the
    `dropDownOpen` state variable to `false`, effectively closing the dropdown menu. */
    useOnClickOutside(dropDownRef, () => {
        setDropDownOpen(false)
    });

    /* The `getDropDownValues` function is a callback function that is used to fetch the dropdown
    values for the ongoing financial years. It is defined using the `useCallback` hook, which
    memoizes the function so that it is only recreated if any of its dependencies change. */
    const getDropDownValues = useCallback(async () => {
        const branch_id = await GetBranchId();
        try {
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing,open`);
            setDropDownValue(res.data.data.financial_years);
            setLoadingDropdown(false);
        } catch (error) {
            // Handle the error here
            console.error('An error occurred:', error);
            setLoadingDropdown(false);
        }
    }, []);

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is used to call the `getDropDownValues` function when the component mounts
    or when the `getDropDownValues` function changes. */
    useEffect(() => {
        getDropDownValues()
    }, [getDropDownValues])

    /**
     * The handleChangeOnGoingFY function sets the status to "ongoing" and the name to the item's name,
     * and closes the dropdown.
     */
    const handleChangeOnGoingFY = (item) => {
        setChangedStatus(item)
        const updatedItem = {
            ...item,
            status: "ongoing"
        };
    
        setChangedOngoingFY(updatedItem);
        setDropDownOpen(false);
    };

    /**
     * The function `handleChangeStatus` is an asynchronous function that handles the change of the
     * ongoing financial year by making a PATCH request to the server and updating the necessary data.
     */
    const handleChangeStatus = async() =>{
        setButtonLoading(true)
        const broadcastChannel = new BroadcastChannel('tab-reload-channel');
        const branch_id = await GetBranchId()
        try {
            const response = await dataService.PatchAPI({"status" : "ongoing", "name" : changedOngoingFY.name}, `financial-years/${branch_id}`);
            if(response?.message === 'Forbidden')  throw error
            handleSidePopupClick();
            localStorage.setItem('FY_details',JSON.stringify(changedOngoingFY))
            setToastmessage("Ongoing FY changed successfully");
            broadcastChannel.postMessage({ type: 'switch_fy' });
            getFinancialYearRecodes()
            setButtonLoading(false)
        } catch (error) {
            // Handle the error here
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error('An error occurred:', error);
            setButtonLoading(false)
        }
    }
    return (
        <SidePopup
            addOpen={true}
            class="bg-''"
            componentName={`Change Ongoing FY`}
            handleSidePopupClick={handleSidePopupClick}
            actionErrorMessage={actionErrorMessage}
            setActionErrorMessage={setActionErrorMessage}
            element={<div className='px-6 pt-[34px]'>
                <p 
                    className='text-[#031624] text-f7 font-normal text-center mx-auto w-[90%]'
                >If an FY is selected as ongoing, the current ongoing &apos;{ongoingFY}&apos; will be changed to Open FY.</p>
                <div className=' mt-[31px] flex items-center border-b border-[D0D5DD] pb-10'>
                    <p className='text-f7 font-normal'>Select Ongoing FY</p>
                    <div className='relative ml-3 w-[250px]' ref={dropDownRef}>
                        <button 
                            id='status-chnage-dropdown'
                            className='slct-inpt-fld' onClick={() => handleDropdownToggle()}>
                            <p 
                                className='text-start text-f7 font-normal text-[#031624] more-lines'
                                title={(changedStatus?.name === "" || changedStatus.name === undefined) ? `${ongoingFY} (Ongoing)` : `${changedStatus.name} (${changedStatus?.status.charAt(0).toUpperCase() + changedStatus?.status.slice(1)})`}
                            >{(changedStatus?.name === "" || changedStatus.name === undefined) ? `${ongoingFY} (Ongoing)` : `${changedStatus.name} (${changedStatus?.status.charAt(0).toUpperCase() + changedStatus?.status.slice(1)})`}</p>
                            <img loading="lazy" src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${dropDownOpen ? "transform rotate-180" : ""}`}/>
                        </button>
                        {dropDownOpen &&
                            <ul className='slct_drp_dwn min-w-full'>
                                {
                                    loadingDropdown ? 
                                        <SearchShimmer /> :
                                        (dropdownValue.map((item) => (
                                            <p key={item._id} 
                                                onClick={() =>  handleChangeOnGoingFY(item)}
                                                className='slct_drp_dwn_optn'>{`${item.name} (${item?.status.charAt(0).toUpperCase() + item?.status.slice(1)})`} </p>))
                                        )}
                            </ul>
                    
                        }
                    </div>
                </div>
                <div class=" flex -mx-2.5 mt-6">
                    <div class="w-1/2">
                        <div class="w-full flex justify-end">
                            <button 
                                onClick={() => handleSidePopupClick()}
                                type="button" 
                                id='Cancel'
                                class="cancl-btn" data-te-modal-dismiss="" aria-label="Close">Cancel</button>
                        </div>
                    </div>
                    <div class="w-1/2">
                        <div class="w-full">
                            <button 
                                type="button" 
                                id="add_admin" 
                                onClick={() => handleChangeStatus()}
                                disabled={changedOngoingFY?.name === "" || changedOngoingFY.name === undefined}
                                class="actn-btn onboardInstitution" 
                                style={{'width':buttonLoading?'102px':'auto'}}
                                tabindex="0"
                            >{buttonLoading ? <Loader /> : "Change"}</button>
                        </div>
                    </div>
                </div>
            </div>
            }
        />
    )
}
